import React, { useState, useEffect } from "react";
import {
  subTitle,
  summary,
} from "../Shared/Styles";

export default function InvestmentDetails() {
    return (
      <div>
        <h3 style={subTitle}>INVESTMENT DETAILS</h3>
        <p style={summary}>There are no investment details.</p>
      </div>
    )
}
